import { http } from "./http";
import { FindAddressByCepRequest, FindAddressByCepResponse } from "@/types/api/viacep";

export async function findAddressByCep(req: FindAddressByCepRequest): Promise<FindAddressByCepResponse> {
  return http.get<FindAddressByCepResponse>(`/api/viacep/${req.cep}`);
}
